import { render, staticRenderFns } from "./diplomaticThoughts.vue?vue&type=template&id=d5247bf8&scoped=true&"
import script from "./diplomaticThoughts.vue?vue&type=script&lang=js&"
export * from "./diplomaticThoughts.vue?vue&type=script&lang=js&"
import style0 from "./diplomaticThoughts.vue?vue&type=style&index=0&id=d5247bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5247bf8",
  null
  
)

export default component.exports